// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_Ohnf5","secondaryColumnCell":"secondary-column-cell_Ohnf5","field":"field_sBsRJ","label":"label_so4SB"};